import { render, staticRenderFns } from "./BackgroundVideo.vue?vue&type=template&id=e7855906&scoped=true"
import script from "./BackgroundVideo.vue?vue&type=script&lang=js"
export * from "./BackgroundVideo.vue?vue&type=script&lang=js"
import style0 from "./BackgroundVideo.vue?vue&type=style&index=0&id=e7855906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7855906",
  null
  
)

export default component.exports